import { GlobalNavigationItemModel } from "client/Api/TitleBar/GlobalNavigation/globalNavigation";

export interface GlobalNavigationItem {
	id: number;
	name: string;
	model: GlobalNavigationItemModel;
	children?: readonly GlobalNavigationItem[];
	activate(mode: GlobalNavigationBarMode): void;
	canActivate(mode: GlobalNavigationBarMode): boolean;
	canDeactivate(mode: GlobalNavigationBarMode): Promise<boolean>;
}

export enum GlobalNavigationBarMode {
	Normal = 0,
	EditSpaceMode = 1
}